<template>
    <div class="firm-group">
        <b-row>
            <csp-desktop-firm-group-basedata :cols="12" :form-context="initialFormContexts.firmGroupBasedata"/>
        </b-row>
        <b-row class="mt-4">
            <csp-desktop-firm-group-firms :cols="12"/>
        </b-row>
        <b-row class="mt-4 mb-4">
            <csp-desktop-firm-configurable-documents :cols="8" :context-id="firmGroupId" context-type="firmGroup"
                :form-context="initialFormContexts.firmConfigurableDocuments"/>
        </b-row>
    </div>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';
    import FirmGroupBasedata from '@desktop/components/firmGroup/detail/FirmGroupBasedata.vue';
    import Container from '@services/Container';
    import FirmGroupFirms from '@desktop/components/firmGroup/detail/FirmGroupFirms.vue';
    import FirmConfigurableDocuments from '@desktop/components/FirmConfigurableDocuments.vue';

    const container = Container.getInstance();
    const firmGroupRepository = container.getDesktopFirmGroupRepository();

    export default {
        name: 'FirmGroupDetails',
        components: {
            'csp-desktop-firm-configurable-documents': FirmConfigurableDocuments,
            'csp-desktop-firm-group-basedata': FirmGroupBasedata,
            'csp-desktop-firm-group-firms': FirmGroupFirms,
        },
        mixins: [FormDataMixin],
        data() {
            const firmGroupId = this.$route.params.firmGroupId;
            return {
                firmGroupId,
                initialFormContexts: {
                    firmGroupBasedata: new FormContext({
                        name: 'firmGroupBasedata',
                        objectId: firmGroupId,
                    }),
                    firmConfigurableDocuments: new FormContext({
                        name: 'firmConfigurableDocuments',
                        objectId: firmGroupId,
                    }),
                },
            };
        },
        created() {
            const loadFunction = () => {
                return firmGroupRepository.loadFirmGroup(this.firmGroupId);
            };
            this.loadFormData(loadFunction);
        },
    }
</script>
